var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('content-block',[_c('h2',{attrs:{"slot":"title"},slot:"title"},[_c('help-icon',{attrs:{"docPath":"/paygate-collections/messaging/messagequeue/"}}),_vm._v("Message Queue"),_c('favourite-icon')],1),_c('messageQueue',{attrs:{"initialFilter":_vm.initialFilter,"canLoad":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }